export enum BookingTypeEnum {
  BLOCK_OFF_HOUR = 'blockOffHour',
  APPOINTMENT = 'appointment',
}
